import { Component, OnInit } from '@angular/core';
import { Project } from 'src/app/models/Project';
import { ApiService } from 'src/app/services/api.service';
declare const $: any;

@Component({
  selector: 'app-projects-important',
  templateUrl: './projects-important.component.html',
  styleUrls: ['./projects-important.component.css']
})
export class ProjectsImportantComponent implements OnInit {
  projects = new Array<Project>();
  mouseIn: number;
  imageDefault = "cog.jpg";
  selectedProject = new Project();

  constructor(private service: ApiService) { }

  async ngOnInit() {
    this.projects = await this.service.getProjects();
    this.projects.sort((a, b) => {
      return a.posizione - b.posizione;
    })
  }
  getBackground(p: Project) {
    if (p.image)
      return '../../../assets/img/progetti/' + p.image;
    return '../../../assets/img/' + this.imageDefault;
  }

  showModalImage(p: Project) {
    if (p.image != this.imageDefault) {
      this.selectedProject = p;
      //show modal
      $('.modal-image').modal('show');
    }
  }
}
